export default [
  {
    id: 1,
    // title: "پست داخلی",
    mainSrc: "/icons/internal.png",
    hoverSrc: "/icons/internal.png",
    url: "preinternal",
  },
  {
    id: 2,
    // title: "پست خارجی",
    mainSrc: "/icons/external.png",
    hoverSrc: "/icons/external.png",
    url: "preexternal",
  },
  {
    id: 3,
    // title: "پیک شهری",
    mainSrc: "/icons/avaBox.png",
    hoverSrc: "/icons/avaBox.png",
    url: "prepeyk",
  },
  {
    id: 4,
    // title: "اپلیکیشن",
    mainSrc: "/icons/app.png",
    hoverSrc: "/icons/app.png",
    url: "preapplication",
  },
  {
    id: 5,
    // title: "اخذ نمایندگی",
    mainSrc: "/icons/agentReq.png",
    hoverSrc: "/icons/agentReq.png",
    url: "preagent",
  },
  {
    id: 6,
    // title: "فروشگاه",
    mainSrc: "/icons/shop.png",
    hoverSrc: "/icons/shop.png",
    url: "preshop",
  },
  {
    id: 7,
    // title: "پشتیبانی",
    mainSrc: "/icons/support.png",
    hoverSrc: "/icons/support.png",
    url: "support",
  },

  {
    id: 8,
    // title: "کیف پول",
    mainSrc: "/icons/wallet.png",
    hoverSrc: "/icons/wallet.png",
    url: "prewallet",
  },

  {
    id: 9,
    // title: "بسته بندی",
    mainSrc: "/icons/packaging.png",
    hoverSrc: "/icons/packaging.png",
    url: "prebox",
  },

  {
    id: 10,
    // title: "درباره ما",
    mainSrc: "/icons/aboutUs.png",
    hoverSrc: "/icons/aboutUs.png",
    url: "about",
  },

  {
    id: 11,
    // title: "پرداخت آنلاین",
    mainSrc: "icons/ourAgents.png",
    hoverSrc: "icons/ourAgents.png",
    url: "agent-list",
  },
];
